export const PROGRESS_STEP_LOCALE_ZHCHS = {
    empty: 'æ­¥éª¤æ¡ä¿¡æ¯ä¸ºç©º'
};